import { createStyles, Theme } from '@zn-material-ui'
export default (theme: Theme) => {
  return createStyles({
    container: {
      margin: '6px 56px 0 0',
      display: 'inline-flex',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    input: {
      width: '310px',
      paddingLeft: '10px',
      height: '32px',
      borderRadius: '2px 0 0 2px',
      border: '1px solid #E5E5E5',
      background: '#F5F5F5',
      fontSize: '14px',
      color: theme.palette.text.primary,
      lineHeight: '24px',
      '&:active': {
        backgroundColor: theme.palette.secondary.main,
        borderRadius: '0px',
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: theme.palette.secondary.main,
      },
    },
    searchImg: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 80,
      height: 36,
      backgroundColor: theme.palette.primary.main,
      borderRadius: '0px 2px 2px 0px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: theme.palette.action.selected,
      },
      '& img': {
        width: 20,
        height: 20,
        '&:avtive': {
          backgroundColor: theme.palette.action.active,
        },
      },
      '& span': {
        lineHeight: '20px',
        fontSize: 14,
        color: theme.palette.secondary.main,
      },
    },
  })
}
